import { render, staticRenderFns } from "./VideoAdapter.vue?vue&type=template&id=3361a8bd&"
import script from "./VideoAdapter.vue?vue&type=script&lang=ts&"
export * from "./VideoAdapter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports